// @flow
import { SERVER_ADDRESS, fetchGet, fetchPost } from '../util/actionsUtil';

export const LOGIN_LOADING = 'LOGIN_LOADING';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_ERROR = 'LOGOUT_ERROR';

export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_ERROR = 'SIGNUP_ERROR';

export const FETCH_ALL_ACCOUNTS_SUCCESS = 'FETCH_ALL_ACCOUNTS_SUCCESS';
export const FETCH_ALL_ACCOUNTS_ERROR = 'FETCH_ALL_ACCOUNTS_ERROR';

export const UPDATE_ACCOUNT_SUCCESS = 'UPDATE_ACCOUNT_SUCCESS';
export const UPDATE_ACCOUNT_ERROR = 'UPDATE_ACCOUNT_ERROR';

export const UPDATE_ACCOUNT_NOTES_SUCCESS = 'UPDATE_ACCOUNT_NOTES_SUCCESS';
export const UPDATE_ACCOUNT_NOTES_ERROR = 'UPDATE_ACCOUNT_NOTES_ERROR';

export function login(username: string, password: string) {
  return ((dispatch: Function) => {
    fetchPost(`${SERVER_ADDRESS}/account/login`,
      { username, password },
      ({ error, activeAccount }) => {
        if (activeAccount) {
          dispatch({
            type: LOGIN_SUCCESS,
            activeAccount,
          });
        } else if (error) {
          dispatch({
            type: LOGIN_ERROR,
            error,
          });
        }
      },
      (error) => {
        dispatch({
          type: LOGIN_ERROR,
          error: error.message,
        });
      });
  });
}

export function logout() {
  return ((dispatch: Function) => {
    fetchGet(`${SERVER_ADDRESS}/account/logout`,
      () => {
        dispatch({
          type: LOGOUT_SUCCESS,
        });
      },
      (error) => {
        dispatch({
          type: LOGOUT_ERROR,
          error,
        });
      });
  });
}

export function signup(userInfo: Object) {
  return ((dispatch: Function) => {
    fetchPost(`${SERVER_ADDRESS}/account/signup`,
      userInfo,
      ({ error, activeAccount }) => {
        if (activeAccount) {
          dispatch({
            type: SIGNUP_SUCCESS,
            activeAccount,
          });
        } else if (error) {
          dispatch({
            type: SIGNUP_ERROR,
            error,
          });
        }
      },
      (error) => {
        dispatch({
          type: SIGNUP_ERROR,
          error: error.message,
        });
      });
  });
}

export function fetchActiveAccount() {
  return ((dispatch: Function) => {
    fetchGet(`${SERVER_ADDRESS}/account/fetchActiveAccount`,
      ({ activeAccount }) => {
        dispatch({
          type: LOGIN_SUCCESS,
          activeAccount,
        });
      },
      (error) => {
        dispatch({
          type: LOGIN_ERROR,
          error: error.message,
        });
      });
    dispatch({
      type: LOGIN_LOADING,
    });
  });
}

export function fetchAllAccounts() {
  return ((dispatch: Function) => {
    fetchGet(`${SERVER_ADDRESS}/account/fetchAllAccounts`,
      ({ allAccounts }) => {
        dispatch({
          type: FETCH_ALL_ACCOUNTS_SUCCESS,
          allAccounts,
        });
      },
      (error) => {
        dispatch({
          type: FETCH_ALL_ACCOUNTS_ERROR,
          error: error.message,
        });
      });
  });
}

export function updateAccount(accountId: string, accountInfo: Object) {
  return ((dispatch: Function) => {
    fetchPost(`${SERVER_ADDRESS}/account/updateAccount`,
      {
        accountId,
        ...accountInfo,
      },
      () => {
        dispatch(fetchActiveAccount());
        dispatch(fetchAllAccounts());
        dispatch({
          type: UPDATE_ACCOUNT_SUCCESS,
        });
      },
      (error) => {
        dispatch({
          type: UPDATE_ACCOUNT_ERROR,
          error: error.message,
        });
      });
  });
}

export function updatePassword(accountId: string, accountInfo: Object) {
  return ((dispatch: Function) => {
    fetchPost(`${SERVER_ADDRESS}/account/updatePassword`,
      {
        accountId,
        ...accountInfo,
      },
      ({ error }) => {
        if (error) {
          dispatch({
            type: UPDATE_ACCOUNT_ERROR,
            error,
          });
        } else {
          dispatch({
            type: UPDATE_ACCOUNT_SUCCESS,
          });
        }
      },
      (error) => {
        dispatch({
          type: UPDATE_ACCOUNT_ERROR,
          error: error.message,
        });
      });
  });
}

export function updateAccountNotes(accountId: string, accountInfo: Object) {
  return ((dispatch: Function) => {
    fetchPost(`${SERVER_ADDRESS}/account/updateAccountNotes`,
      {
        accountId,
        ...accountInfo,
      },
      ({ error }) => {
        if (error) {
          dispatch({
            type: UPDATE_ACCOUNT_NOTES_ERROR,
            error,
          });
        } else {
          dispatch({
            type: UPDATE_ACCOUNT_NOTES_SUCCESS,
          });
          dispatch(fetchAllAccounts());
        }
      },
      (error) => {
        dispatch({
          type: UPDATE_ACCOUNT_NOTES_ERROR,
          error: error.message,
        });
      });
  });
}



// WEBPACK FOOTER //
// ./client/src/actions/accountActions.js